"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSelectableProps = getSelectableProps;
exports.getChildren = getChildren;
exports.useSelectInline = useSelectInline;
exports.SelectInline = SelectInline;
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _useSelectState = _interopRequireDefault(require("../useSelectState"));

function getSelectableProps(controller, props) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var value = controller.value,
      options = controller.options,
      setValue = controller.setValue,
      multi = controller.multi,
      isSelected = controller.isSelected;
  var _config$allowUnselect = config.allowUnselect,
      allowUnselect = _config$allowUnselect === void 0 ? true : _config$allowUnselect; // this flag is important. In dropdown select even if we have allowEmpty=true, clicking on selected option doesn't unselect it. It does for SelectInline however.

  var selectableProps = options.map(function (option) {
    return {
      selected: isSelected(option),
      disabled: option.disabled,
      invalid: !!props.invalid,
      option: option,
      key: option.id,
      label: option.label,
      onClick: function onClick() {
        if (option.disabled) {
          return;
        }

        if (controller.isSelected(option)) {
          if (multi || props.allowEmpty !== false && allowUnselect) {
            controller.unselectValue(option);
          }
        } else {
          controller.selectValue(option);
        }
      }
    };
  });
  return selectableProps;
}

function getChildren(controller, props) {
  var children = props.children;

  try {
    var item;

    if (props.selectable) {
      item = props.selectable;
    } else {
      item = _react["default"].Children.only(children);
    }

    children = function children(_ref) {
      var selectableProps = _ref.selectableProps;
      return selectableProps.map(function (props) {
        return _react["default"].cloneElement(typeof item === "function" ? item({
          option: props.option
        }) : item, props);
      });
    };
  } catch (error) {}

  children = children(controller);
  return children;
}

function useSelectInline(props) {
  var controller = (0, _useSelectState["default"])(props);
  return (0, _objectSpread2["default"])({}, controller, {
    selectableProps: getSelectableProps(controller, props)
  });
}

function SelectInline(_ref2) {
  var controller = _ref2.controller,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["controller"]);

  if (!controller) {
    controller = useSelectInline(props);
  }

  return getChildren(controller, props);
} // TODO: accessibility


var _default = SelectInline;
exports["default"] = _default;